//noinspection JSFileReferences
import components from './components';

export default {
	_modules: [],
	init() {
		const queryString = window.location.search;
        for (let i in components) {
            let component = components[i];

            if (typeof component === 'object' && component.hasOwnProperty('default') && !component.hasOwnProperty('_modules')) {
                if (queryString.search('debug=npm') != -1) {
                    console.log('loaded: '+component.default.name);
                }

                component.default.hasOwnProperty('init') ? component.default.init() : null;
            }
        }
	}
}